module.exports = __webpack_public_path__ + "assets/images/bnz-small-logo.7a91a1ed36d146e31c9d8c2c9498439e.png";


//////////////////
// WEBPACK FOOTER
// ../fraedom-assets/images/flexi/bnz-small-logo.png
// module id = 589
// module chunks = 0